var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "adicionarPvtnContainer" } },
    [
      _c("pvtn-vigencia-card", {
        attrs: { pvtn: _vm.pvtn, isVisualizar: _vm.isVisualizar }
      }),
      _vm._l(_vm.pvtn.pvtnRequests, function(pvtnRequest, index) {
        return _c("pvtn-municipio-card", {
          key: index,
          attrs: { pvtnRequest: pvtnRequest, isVisualizar: _vm.isVisualizar },
          on: {
            aplicarValores: function($event) {
              return _vm.aplicarValores(pvtnRequest)
            }
          }
        })
      }),
      _c("app-buttons-cadastro", {
        attrs: {
          showButtonSalvar: !_vm.isVisualizar,
          showButtonCancelar: false,
          showButtonProximo: false,
          showButtonFinalizar: !_vm.isVisualizar,
          isUltimoPasso: true,
          isPrimeiroPasso: false
        },
        on: { voltar: _vm.voltar, salvar: _vm.salvar, finalizar: _vm.finalizar }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa735f80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa735f80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/AdicionarPvtn.vue
// module id = null
// module chunks = 